import $ from "jquery";

// functions from RequiredFieldService
const setRequiredAttribute = ($dom, identifier) => {
  $dom.find(identifier).prop("required", true);
};

const removeRequiredAttribute = ($dom, identifier) => {
  $dom.find(identifier).removeAttr("required");
};

// function from TemplateService
const getFilledTemplate = (templateIdentifier, valueJSON) => {
  let template = $(templateIdentifier).html();

  Object.keys(valueJSON).forEach((marker) => {
    // build a global regexp
    const regex = new RegExp(marker, "g");

    template = template.replace(regex, (matched) => valueJSON[matched]);
  });

  return $(template);
};

// functions from GimmickService
const generateGimmicks = (items, container, $machine) => {
  $.each(items, (i, item) => {
    $machine
      .find(container)
      .append(getFilledTemplate(".gimmick-template", { "###title###": item }));
  });
};

const cleanUpGimmicks = ($area, content) => {
  $area.find(content).empty();
};

// function from VisibilityService
const activateDescriptions = ($dom) => {
  $dom.find(".js-form-description").click((e) => {
    $(e.currentTarget).toggleClass("active");
    $dom
      .find(".js-form-description-container")
      .slideToggle("slow")
      .toggleClass("active");
  });
};

export {
  generateGimmicks,
  cleanUpGimmicks,
  setRequiredAttribute,
  removeRequiredAttribute,
  activateDescriptions,
  getFilledTemplate,
};
